export const AVAILABILITY_AVAILABLE = 'available';
export const AVAILABILITY_EXCLUDED = 'excluded';

export const errorMessage = (error) => error?.response?.data?.message || $t('Something went wrong. Please try again.');
